import React from "react";
import { useStoreOptionsQuery } from "@queries/store";
import { useMarketplace } from "@context/MarketplaceContext";

const ORDER_TYPES = [
  "car_cleaning",
  "normal",
  "skip",
  "express",
  "complementary",
  "disinfection",
  "furniture",
  "housekeeping",
  "carpets",
  "chemicals",
];

const ORDER_STATUSES = [
  { id: 2, name: "Processing" },
  { id: 5, name: "Complete" },
  { id: 7, name: "Canceled" },
  { id: 13, name: "Chargeback" },
  { id: 15, name: "Pick up" },
  { id: 17, name: "Cleaning" },
  { id: 18, name: "Delivery" },
  { id: 21, name: "Skip Selection" },
  { id: 22, name: "Reschedule" },
  { id: 23, name: "Pending for customer support" },
];

const initial = {
  orderId: "",
  customerId: "",
  invoiceNo: "",
  orderType: "",
  orderStatus: "",
  storeId: "",
  unpaidOnly: false,
  rescheduleOnly: false,
  firstTimeOnly: false,
  outSourceOnly: false,
  dateFrom: "",
  dateTo: "",
};

export default function OrdersFilter({ value, onChange }) {
  const [form, setForm] = React.useState(value || initial);
  // Stores of the active marketplace — same scope as the orders list itself.
  const { activeMarketplaceId } = useMarketplace();
  const { data: storeOpts = [] } = useStoreOptionsQuery(activeMarketplaceId);

  React.useEffect(() => {
    setForm(value || initial);
  }, [value]);

  const setField = (k, v) => {
    const next = { ...form, [k]: v };
    setForm(next);
  };

  const submit = (e) => {
    e?.preventDefault?.();
    onChange?.(form);
  };

  const reset = () => {
    setForm(initial);
    onChange?.(initial);
  };

  return (
    <form onSubmit={submit}>
      <div className="oc-f-grid orders-filter-grid">
        <div className="oc-field">
          <label>Order ID</label>
          <input className="oc-input" placeholder="Order ID"
            value={form.orderId} onChange={(e)=>setField("orderId",e.target.value)} />
        </div>
        <div className="oc-field">
          <label>Customer ID</label>
          <input className="oc-input" placeholder="Customer ID"
            value={form.customerId} onChange={(e)=>setField("customerId",e.target.value)} />
        </div>
        <div className="oc-field">
          <label>Invoice No</label>
          <input className="oc-input" placeholder="Invoice No"
            value={form.invoiceNo} onChange={(e)=>setField("invoiceNo",e.target.value)} />
        </div>

        <div className="oc-field large">
          <label>Order Type</label>
          <select className="oc-select" value={form.orderType}
            onChange={(e)=>setField("orderType",e.target.value)}>
            <option value="">All</option>
            {ORDER_TYPES.map((t) => (
              <option key={t} value={t}>{t}</option>
            ))}
          </select>
        </div>

        <div className="oc-field large">
          <label>Order Status</label>
          <select className="oc-select" value={form.orderStatus}
            onChange={(e)=>setField("orderStatus",e.target.value)}>
            <option value="">All</option>
            {ORDER_STATUSES.map((s) => (
              <option key={s.id} value={s.id}>{s.name}</option>
            ))}
          </select>
        </div>

        <div className="oc-field large">
          <label>Store</label>
          <select className="oc-select" value={form.storeId ?? ""}
            onChange={(e)=>setField("storeId",e.target.value)}>
            <option value="">All</option>
            {form.storeId && !storeOpts.some((s) => String(s.store_id) === String(form.storeId)) && (
              <option value={form.storeId}>Store #{form.storeId}</option>
            )}
            {storeOpts.map((s) => (
              <option key={s.store_id} value={String(s.store_id)}>{s.name}</option>
            ))}
          </select>
        </div>

        <div className="oc-checks">
          <label><input type="checkbox" checked={form.unpaidOnly}
            onChange={(e)=>setField("unpaidOnly",e.target.checked)} /> Unpaid Orders</label>
          <label><input type="checkbox" checked={form.rescheduleOnly}
            onChange={(e)=>setField("rescheduleOnly",e.target.checked)} /> Reschedule Orders</label>
          <label><input type="checkbox" checked={form.firstTimeOnly}
            onChange={(e)=>setField("firstTimeOnly",e.target.checked)} /> First Time Order</label>
          <label><input type="checkbox" checked={form.outSourceOnly}
            onChange={(e)=>setField("outSourceOnly",e.target.checked)} /> Out Source</label>
        </div>

        <div className="oc-field">
          <label>Date From</label>
          <input type="date" className="oc-input"
            value={form.dateFrom} onChange={(e)=>setField("dateFrom",e.target.value)} />
        </div>
        <div className="oc-field">
          <label>Date To</label>
          <input type="date" className="oc-input"
            value={form.dateTo} onChange={(e)=>setField("dateTo",e.target.value)} />
        </div>

        <div className="oc-actions">
          <button className="oc-btn" type="submit">Filter</button>
          <button className="oc-btn ghost" type="button" onClick={reset}>Reset</button>
        </div>
      </div>
    </form>
  );
}

